import configureAxios from 'configure/axios';

const axios = configureAxios();

export const autopay = (userId, enabled) => axios.post(`users/${userId}/autopay/`, { enabled });
